import GlobalKeybindings, {
  HandlerMap,
  invokeHandler,
} from 'common/lib/util/global-keybindings';
import React, { ReactElement } from 'react';
import { Key as KeyEnum } from 'types/keys';

interface KeybindingsProps {
  keybindings: HandlerMap;
  children: ReactElement;
}

export default class Keybindings extends React.Component<KeybindingsProps> {
  // register or unregister callbacks, consolidated for DRYness
  private toggle = (fn: (handlerMap: HandlerMap) => void) => {
    const { keybindings } = this.props;
    for (const key in keybindings) {
      const handler = keybindings[key];
      if (handler.isGlobal) {
        fn({ [key]: { ...handler } });
      }
    }
  };

  constructor(props: KeybindingsProps) {
    super(props);
    this.toggle(GlobalKeybindings.register);
  }

  componentWillUnmount() {
    this.toggle(GlobalKeybindings.unregister);
  }

  handleKeydown = (evt: React.KeyboardEvent<HTMLElement>) => {
    const { key } = evt;
    const handler = this.props.keybindings[key];

    // don't invoke handlers if they're global, leave that to the provider
    if (handler && !handler.isGlobal) {
      invokeHandler(evt, handler);
    }
  };

  render() {
    const child = React.Children.only(this.props.children);
    const { tabIndex } = child.props;

    return React.cloneElement(child, {
      onKeyDown: this.handleKeydown,
      tabIndex: tabIndex || -1,
    });
  }
}

// exporting as-is for convenience
export const Key = KeyEnum;



// WEBPACK FOOTER //
// ./app/gamma/src/components/shared/keybindings.tsx